import { AxiosRequestConfig } from 'axios';

const endpoint = 'api/cities';

export default {
    retrieveCity: (id: number) => ({ method: 'GET', url: `${endpoint}/${id}` } as AxiosRequestConfig),
};
